import dayjs from 'dayjs';

const getDiffInMinutes = (date: Date, compareToDate?: Date): number =>
	Math.abs(dayjs(compareToDate).diff(date, 'minutes'));

export default getDiffInMinutes;
